import { render, staticRenderFns } from "./SessionsNew.vue?vue&type=template&id=83528be8&scoped=true&"
import script from "./SessionsNew.vue?vue&type=script&lang=js&"
export * from "./SessionsNew.vue?vue&type=script&lang=js&"
import style0 from "./SessionsNew.vue?vue&type=style&index=0&id=83528be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83528be8",
  null
  
)

export default component.exports